import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Alert,
    Snackbar
} from "@mui/material";

import CircularProgress from "@mui/material/CircularProgress";

import { MdDeleteOutline, MdOutlineModeEdit } from "react-icons/md";
import { categories } from "../../../data/category.js";
import { useOutletContext } from "react-router-dom";
import { useGetAllProductsQuery } from "../../../redux/slices/admin/product/manageProducts.js";
import { useDeleteProductMutation } from "../../../redux/slices/admin/product/manageProductsDelete.js";
import { Pagination } from "@mui/material";

import {
    useUpdateConsignedMutation,
    useUpdateOwnedMutation,
    useUpdateOtherMutation
} from "../../../redux/slices/admin/product/manageProductEditSlince.js";

import "../../../styles/admin.css/products-css/manage-products.css";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils.js";

export default function ManageProducts() {
    const { sidebarOpen } = useOutletContext();
    const { data, isLoading, error, refetch } = useGetAllProductsQuery();
    const products = data?.data || [];
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;

    const [updateConsigned] = useUpdateConsignedMutation();
    const [updateOwned] = useUpdateOwnedMutation();
    const [updateOther] = useUpdateOtherMutation();

    const [deletingId, setDeletingId] = useState(null);
    const [deleteProduct] = useDeleteProductMutation();
    const [search, setSearch] = useState("");
    const [category, setCategory] = useState("Hamısı");
    const [subCategory, setSubCategory] = useState("Hamısı");
    const [quantityFilter, setQuantityFilter] = useState("Hamısı");
    const [openRow, setOpenRow] = useState(null);
    const [editValues, setEditValues] = useState({});


    const [errors, setErrors] = useState({});
    const [toast, setToast] = useState({ open: false, severity: "success", message: "" });


    useEffect(() => {
        setPage(1);
    }, [search, category, subCategory, quantityFilter]);

    const handleCloseToast = () => {
        setToast({ ...toast, open: false });
    };

    useEffect(() => {
        refetch();
    }, []);

    const handleBlur = (field, originalValue) => {
        const currentValue = editValues[field];

        const sub = editValues.subcategoryName;
        const oilGroup = ["Motor yağı", "Transmissiya yağı", "Antifriz"];
        const isOilGroup = oilGroup.includes(sub);

        if (!currentValue || String(currentValue).trim() === "") {
            setEditValues(prev => ({ ...prev, [field]: originalValue }));
        } else if (field === "quantity" && parseInt(currentValue) === 0 && !isOilGroup) {
            setEditValues(prev => ({ ...prev, [field]: 1 }));
        }
    };

    const handleTextInput = (field, value) => {
        handleInputChange(field, value);
    };

    const handleQuantityInput = (field, value) => {

        if (/^\d*$/.test(value)) {

            handleInputChange(field, value);
        }
    };


    const handleDecimalInput = (field, value) => {
        if (value === "" || /^\d*\.?\d*$/.test(value)) {
            handleInputChange(field, value);
        }
    };

    const handleInputChange = (field, value) => {
        setEditValues(prev => ({ ...prev, [field]: value }));
    };

    const handleEditClick = (prod) => {
        if (openRow === prod.id) handleCancel();
        else {
            setOpenRow(prod.id);
            const oilGroup = ["Motor yağı", "Transmissiya yağı", "Antifriz"];
            const isOil = oilGroup.includes(prod.subcategoryName);
            setEditValues({
                ...prod,
                // For OIL: quantity = how many bidons to ADD (not total)
                quantity: isOil ? "" : prod.quantity,
                // Default new liter = existing liter per bidon
                addedLiter: isOil ? (prod.liter ?? prod.literForOneBidon ?? "") : ""
            });
        }
    };


    const handleCancel = () => {
        setOpenRow(null);
        setEditValues({});
    };

    const handleSave = async () => {
        const subName = editValues.subcategoryName;
        const catName = editValues.categoryName;


        const foundCategory = categories.find(c => c.category === catName);
        const categoryId = foundCategory ? foundCategory.id : 0;


        const foundSub = foundCategory?.subCategories.find(sc => sc.name === subName);
        const subcategoryId = foundSub ? foundSub.id : 0;


        const commonData = {
            updatedProductId: editValues.id,
            name: editValues.name,
            categoryId: categoryId,
            subcategoryId: subcategoryId,
            quantity: Number(editValues.quantity),
            sellPrice: Number(editValues.sellPrice),
        };

        try {
            if (subName === "Motor yağı" || subName === "Transmissiya yağı" || subName === "Antifriz") {
                const payload = {
                    updatedProductId: editValues.id,
                    name: editValues.name,
                    categoryId: categoryId,
                    subcategoryId: subcategoryId,
                    sellPrice: Number(editValues.sellPrice),
                    // addedQuantity = how many bidons to ADD on top of existing
                    addedQuantity: Number(editValues.quantity) || 0,
                    newLiterPerBidon: Number(editValues.addedLiter) || null,
                    fuelType: editValues.fuelType,
                    costPrice: Number(editValues.costPrice),
                    code: editValues.code,
                    color: String(editValues.color),
                };
                await updateConsigned(payload).unwrap();

            } else if (subName === "Hava filtiri" || subName === "Yağ filtiri" || subName === "Benzin filtiri" || subName === "Salon filtiri" || subName === "Transmissiya filtiri") {
                const payload = {
                    ...commonData,
                    fuelType: editValues.fuelType,
                    costPrice: Number(editValues.costPrice),
                    code: editValues.code
                };
                await updateOwned(payload).unwrap();

            } else {
                const payload = {
                    ...commonData,
                    costPrice: Number(editValues.costPrice)
                };
                await updateOther(payload).unwrap();

            }

            setToast({ open: true, severity: "success", message: "Məhsul uğurla yeniləndi!" });
            setOpenRow(null);
            setEditValues({});
            refetch();
        } catch (err) {
            setToast({ open: true, severity: "error", message: "Yeniləmə zamanı xəta baş verdi!" });
            console.error("Update Error:", err);
        }
    };

    const getTableHeaders = () => {

        if (subCategory === "Hava filtiri" || subCategory === "Yağ filtiri" || subCategory === "Benzin filtiri" || subCategory === "Salon filtiri" || subCategory === "Transmissiya filtiri") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Yanacaq Növləri", "Miqdar", "Maya deyəri", "Kod", "Satis Qiymət", "Seçimlər"];
        } else if (subCategory === "Motor yağı" || subCategory === "Transmissiya yağı") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Yanacaq Növləri", "Miqdar", "Maya deyəri", "Litr", "Cəm Litr", "Kod", "Satis Qiymət", "Seçimlər"];
        } else if (subCategory === "Antifriz") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Yanacaq Növləri", "Miqdar", "Maya deyəri", "Litr", "Kod", "Satis Qiymət", "Rəng", "Seçimlər"];
        }
        else if (subCategory === "Əyləc mayesi") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Miqdar", "Maya deyəri", "Litr", "Cəm Litr", "Satis Qiymət", "Seçimlər"];
        }
        else {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Miqdar", "Maya deyəri", "Satis Qiymət", "Seçimlər"];
        }
    };

    const handleDelete = async (prod) => {
        setDeletingId(prod.id);
        try {
            await deleteProduct(String(prod.id)).unwrap();
            setToast({ open: true, severity: "success", message: "Məhsul silindi!" });
            refetch();
        } catch (err) {
            console.error(err);
            setToast({ open: true, severity: "info", message: "Silmək mümkün olmadı!" });
        }
        setDeletingId(null);
    };





    const filtered = products
        .filter(p => {
            const s = search.toLowerCase();
            const matchCategory = category === "Hamısı" || p.categoryName === category;
            const matchSubCategory = subCategory === "Hamısı" || p.subcategoryName?.trim() === subCategory.trim();
            const matchSearch = p.name.toLowerCase().includes(s);
            return matchCategory && matchSubCategory && matchSearch;
        })
        .sort((a, b) => {
            if (quantityFilter === "Azdan Çoxa") {
                return a.quantity - b.quantity;
            } else if (quantityFilter === "Çoxdan Aza") {
                return b.quantity - a.quantity;
            }
            return 0;
        });


    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedData = filtered.slice(startIndex, startIndex + itemsPerPage);
    const renderPagination = () => (
        <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 2, backgroundColor: '#fff' }}>
            <Pagination
                count={totalPages}
                page={page}
                onChange={(e, value) => {
                    setPage(value);

                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                color="primary"
                variant="outlined"
                shape="rounded"
                showFirstButton
                showLastButton
            />
        </Box>
    );
    const renderTableCell = (prod, header, index) => {
        switch (header) {
            case "#No": return "#" + String(prod.serialNo || prod.id).padStart(4, "0");
            case "Məhsul Adı": return prod.name;
            case "Kateqoriya": return prod.categoryName;
            case "Alt-kateqoriya": return prod.subcategoryName;
            case "Yanacaq Növləri": return prod.fuelType || "-";
            case "Miqdar": 
                return ["Motor yağı", "Transmissiya yağı"].includes(prod.subcategoryName)
                    ? Math.ceil(parseFloat(prod.quantity))
                    : prod.quantity;
            case "Maya deyəri": return prod.costPrice !== null ? prod.costPrice + "₼" : "-";
            case "Litr": return prod.liter ? prod.liter + "L" : "-";
            case "Cəm Litr": return prod.totalLiter ? prod.totalLiter + "L" : "-";
            case "Rəng": return String(prod.color) ? String(prod.color) : "-";
            case "Kod": return prod.code || "-";
            case "Satis Qiymət": return prod.sellPrice + "₼";
            case "Seçimlər":
                return (
                    <Box className="manage-wrapper">
                        <Button size="small" variant="contained"
                            className="manage-products-btnn"
                            onClick={() => handleEditClick(prod)}
                        >
                            <MdOutlineModeEdit style={{ width: "24px", height: "24px" }} />
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            color="error"
                            className="manage-products-btnn-delete"
                            onClick={() => handleDelete(prod)}
                            disabled={deletingId === prod.id}
                        >
                            {deletingId === prod.id ? (
                                <CircularProgress size={24} style={{ color: "white" }} />
                            ) : (
                                <MdDeleteOutline style={{ width: "24px", height: "24px" }} />
                            )}
                        </Button>


                    </Box>
                );
            default: return "";
        }
    };

    const renderInputs = (prod) => {
        const sub = prod.subcategoryName;


        const filterGroup = ["Yağ filtiri", "Hava filtiri", "Benzin filtiri", "Salon filtiri", "Transmissiya filtiri"];
        const oilGroup = ["Motor yağı", "Transmissiya yağı", "Antifriz"];



        const isOilOrFilter = [...filterGroup, ...oilGroup].includes(sub);

        return (
            <>
                <TextField
                    label="Məhsul Adı"
                    size="small"
                    fullWidth
                    margin="dense"
                    value={editValues.name || ""}
                    onChange={(e) => handleTextInput("name", e.target.value)}
                    onBlur={() => handleBlur("name", prod.name)}
                />

                {isOilOrFilter && (
                    <FormControl size="small" fullWidth margin="dense">
                        <InputLabel>Yanacaq Növləri</InputLabel>
                        <Select
                            label="Yanacaq Növləri"
                            value={editValues.fuelType || ""}
                            onChange={(e) => handleInputChange("fuelType", e.target.value)}
                        >
                            <MenuItem value="Benzin">Benzin</MenuItem>
                            <MenuItem value="Hybrid">Hybrid</MenuItem>
                            <MenuItem value="Dizel">Dizel</MenuItem>
                            <MenuItem value="Benzin / Dizel">Benzin / Dizel</MenuItem>
                        </Select>
                    </FormControl>
                )}

                <TextField
                    label={oilGroup.includes(sub) ? `Əlavə et (miqdar) — Cari: ${prod.quantity}` : "Miqdar"}
                    size="small"
                    fullWidth
                    margin="dense"
                    value={editValues.quantity ?? ""}
                    onChange={(e) => handleQuantityInput("quantity", e.target.value)}
                    onBlur={() => oilGroup.includes(sub) ? null : handleBlur("quantity", prod.quantity)}
                    disabled={prod.quantity === 0 && !oilGroup.includes(sub)}
                />


                <TextField
                    label="Maya dəyəri"
                    size="small"
                    fullWidth
                    margin="dense"
                    value={editValues.costPrice || ""}
                    onChange={(e) => handleDecimalInput("costPrice", e.target.value)}
                    onBlur={() => handleBlur("costPrice", prod.costPrice)}
                />



                {sub === "Antifriz" && (
                    <TextField
                        label="Rəng"
                        size="small"
                        fullWidth
                        margin="dense"
                        value={editValues.color || ""}
                        onChange={(e) => handleTextInput("color", e.target.value)}
                        onBlur={() => handleBlur("color", prod.color)}
                    />
                )}

                {isOilOrFilter && (
                    <TextField
                        label="Kod"
                        size="small"
                        fullWidth
                        margin="dense"
                        value={editValues.code || ""}
                        onChange={(e) => handleTextInput("code", e.target.value)}
                        onBlur={() => handleBlur("code", prod.code)}
                    />
                )}

                <TextField
                    label="Satis Qiymət"
                    size="small"
                    fullWidth
                    margin="dense"
                    value={editValues.sellPrice || ""}
                    onChange={(e) => handleDecimalInput("sellPrice", e.target.value)}
                    onBlur={() => handleBlur("sellPrice", prod.sellPrice)}
                />
            </>
        );
    };
    return (
        <Box className={`manage-products-container ${sidebarOpen ? "sidebar-open" : ""}`} style={{ overflowY: "auto", maxHeight: "100vh" }}>
            <Box className="manage-products-header">
                <Box className="manage-products-title">
                    <Typography style={{ color: "#545A61" }}>Məhsulların idarə edilməsi</Typography>
                    <Divider className="manage-products-divider" />
                </Box>

                <Box className="filters-row">
                    <Box style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                        <FormControl size="small">
                            <InputLabel>Kateqoriya seçim</InputLabel>
                            <Select
                                label="Kateqoriya seçim"
                                value={category}
                                onChange={(e) => { setCategory(e.target.value); setSubCategory("Hamısı"); }}
                                style={{ width: 180 }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 300,
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                }}
                            >
                                <MenuItem value="Hamısı">Hamısı</MenuItem>
                                {categories.map((c, i) => (<MenuItem key={i} value={c.category}>{c.category}</MenuItem>))}
                            </Select>
                        </FormControl>

                        <FormControl size="small">
                            <InputLabel>Alt-kateqoriya</InputLabel>
                            <Select
                                label="Alt-kateqoriya"
                                value={subCategory}
                                onChange={(e) => setSubCategory(e.target.value)}
                                style={{ width: 180 }}
                                disabled={category === "Hamısı"}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 250,
                                            width: 180,
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                }}
                            >
                                <MenuItem value="Hamısı">Hamısı</MenuItem>
                                {categories
                                    .find((c) => c.category === category)
                                    ?.subCategories.map((sc) => (

                                        <MenuItem key={sc.id} value={sc.name}>
                                            {sc.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small">
                            <InputLabel>Miqdar</InputLabel>
                            <Select
                                label="Miqdar"
                                value={quantityFilter}
                                onChange={(e) => { setQuantityFilter(e.target.value); }}
                                style={{ minWidth: 150 }}
                            >
                                <MenuItem value="Hamısı">Hamısı</MenuItem>
                                <MenuItem value="Azdan Çoxa">Azdan Çoxa</MenuItem>
                                <MenuItem value="Çoxdan Aza">Çoxdan Aza</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <TextField size="small" placeholder="Axtar..." className="manage-products-search" value={search} onChange={(e) => setSearch(e.target.value)} />
                </Box>
            </Box>

            <Table className="manage-products-table">
                <TableHead>
                    <TableRow>
                        {getTableHeaders().map((header, i) => (<TableCell key={i}>{header}</TableCell>))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {isLoading ? (
                        <TableRow><TableCell colSpan={getTableHeaders().length} align="center">Yüklənir...</TableCell></TableRow>
                    ) : paginatedData.length === 0 ? (
                        <TableRow><TableCell colSpan={getTableHeaders().length} align="center">Məlumat tapılmadı</TableCell></TableRow>
                    ) : (
                        paginatedData.map((prod, index) => (
                            <React.Fragment key={prod.id}>
                                <TableRow>
                                    {getTableHeaders().map((header, i) => (
                                        <TableCell key={i}>{renderTableCell(prod, header, index)}</TableCell>
                                    ))}
                                </TableRow>
                                {openRow === prod.id && (
                                    <TableRow>
                                        <TableCell colSpan={getTableHeaders().length} className="expanded-row-cell">
                                            <Box className="expanded-details">
                                                {renderInputs(prod)}
                                                <Box className="edit-actions">
                                                    <Button variant="outlined" size="small" onClick={handleCancel}>Ləğv et</Button>
                                                    <Button variant="contained" size="small" color="primary" onClick={handleSave}>Təsdiqlə</Button>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        ))
                    )}
                </TableBody>
            </Table>
            {filtered.length > itemsPerPage && renderPagination()}
            <Snackbar
                open={toast.open}
                autoHideDuration={4000}
                onClose={handleCloseToast}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
